<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $t('referrals') }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      hide-actions
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.name }} </td>
            <td> {{ props.item.total | currency }} </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Referral from '@/client/referral'

export default {
  name: 'ReferralsView',

  props: {},

  data () {
    return {
      headers: [
        { text: this.$t('attrs.name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('attrs.total'), align: 'left', sortable: true, value: 'total' }
      ],
      items: [],
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      this.items = await Referral.all()
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
    this.fetch()
  }
}
</script>
